import { all_accepted_formats, video_formats } from "constants/recordedContent";

export const max_uploadable_file_size_in_mb = 50;
export const max_uploadable_files_limit = 5;
export const all_formats_dispute_documents = [
  ...all_accepted_formats,
  ...video_formats,
];
